const state = {
    residenceEmployee: {},
    editAddress: true
}

const mutations = {
    SET_RESIDENCE(state, payload) {
        state.residenceEmployee = payload.target
        state.editAddress = payload.editAddress
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};